"use client";

import { useEffect, useMemo, useState } from "react";

import type { Project } from "@/data";
import {
  PROJECTS_UPDATED_EVENT,
  getAdminProjects,
  getHiddenDefaultProjectIds,
} from "@/lib/projectStorage";

export const usePortfolioProjects = (defaultProjects: Project[]) => {
  const [adminProjects, setAdminProjects] = useState<Project[]>([]);
  const [hiddenDefaultProjectIds, setHiddenDefaultProjectIds] = useState<string[]>([]);

  useEffect(() => {
    const syncProjects = () => {
      setAdminProjects(getAdminProjects());
      setHiddenDefaultProjectIds(getHiddenDefaultProjectIds());
    };

    syncProjects();
    window.addEventListener("storage", syncProjects);
    window.addEventListener(PROJECTS_UPDATED_EVENT, syncProjects);

    return () => {
      window.removeEventListener("storage", syncProjects);
      window.removeEventListener(PROJECTS_UPDATED_EVENT, syncProjects);
    };
  }, []);

  return useMemo(() => {
    const visibleDefaultProjects = defaultProjects.filter(
      (project) => !hiddenDefaultProjectIds.includes(String(project.id))
    );

    return [...adminProjects, ...visibleDefaultProjects];
  }, [adminProjects, defaultProjects, hiddenDefaultProjectIds]);
};
